import { render, staticRenderFns } from "./BaseColumn.vue?vue&type=template&id=76e530e0&scoped=true"
import script from "./BaseColumn.vue?vue&type=script&lang=js"
export * from "./BaseColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e530e0",
  null
  
)

export default component.exports